<template>
  <div class="integral">
    <!-- 搜索 -->
    <div class="integralSearch">
      <el-input v-model="activityName" placeholder="活动名称"></el-input>
      <el-date-picker v-model="createTime" value-format="yyyy-MM-dd" type="date" placeholder="创建时间">
      </el-date-picker>
      <div class="timeSearch">
        <el-date-picker
          v-model="activityDate"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="活动开始日期"
          end-placeholder="活动结束日期"
        >
        </el-date-picker>
      </div>
      <el-select v-model="activityProcess" placeholder="活动状态">
        <el-option label="全部" value=""> </el-option>
        <el-option label="未发布" value="UNPUBLISH"> </el-option>
        <el-option label="准备中" value="PREPARING"> </el-option>
        <el-option label="进行中" value="PROCESSING"> </el-option>
        <el-option label="已结束" value="FINISHED"> </el-option>
      </el-select>
      <el-button class="searchBtn" @click="search">搜索</el-button>
      <el-button type="text" class="resetBtn" @click="resetData">
        <i class="iconfont icon-qingchushujuku"></i>
        <span>清除条件</span>
      </el-button>
    </div>
    <!-- 添加 -->
    <div class="toolRight">
      <el-button type="primary" size="small" @click="toDialog('add')"
        ><i class="el-icon-circle-plus-outline"></i>添加
      </el-button>
    </div>
    <!-- table -->
    <div class="integralTable">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        class="tableContent"
      >
        <el-table-column
          prop="activityName"
          label="活动名称"
          header-align="center"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="categoryName"
          label="商品分类"
          header-align="center"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="exchangeRate"
          label="现金积分规则"
          header-align="center"
          show-overflow-tooltip
          width="150"
          align="center"
          :formatter="formatterExchangeRate"
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          align="center"
          header-align="center"
          label="创建时间"
          :formatter="formatterCreateDate"
        >
        </el-table-column>
        <el-table-column
          prop="actDate"
          align="center"
          header-align="center"
          label="活动时间"
          :formatter="formatterActivityDate"
        >
        </el-table-column>
        <el-table-column
          prop="storeNum"
          align="center"
          header-align="center"
          width='100'
          label="活动店铺数"
        >
        </el-table-column>
        <el-table-column
          prop="goodsNum"
          align="center"
          header-align="center"
          width='100'
          label="活动商品数"
        >
        </el-table-column>
        <el-table-column
          prop="exchangeNum"
          align="center"
          header-align="center"
          width='100'
          label="兑换数量"
        >
        </el-table-column>
        <el-table-column
          prop="earnPoints"
          align="center"
          header-align="center"
          width='100'
          label="兑换积分"
        >
        </el-table-column>
        <el-table-column
          prop="activityProcesseCn"
          align="center"
          header-align="center"
          label="活动状态"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="150"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              v-if="scope.row.activityProcesseCn == '未发布'"
               @click="toDialog('edit', scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              size="small"
              v-if="scope.row.activityProcesseCn == '未发布'"
              @click="delActivity(scope.row.uuid)"
              >删除</el-button
            >
            <el-button
              type="text"
              size="small"
              v-if="scope.row.activityProcesseCn !== '未发布'"
              @click="copyUrl(scope.row)"
              >活动地址</el-button
            >
            <el-button type="text" size="small" @click="handleIntegralDetails(scope.row.uuid)">查看</el-button>
            <div>
              <el-button
                type="text"
                size="small"
                @click="handleManagement('store', scope.row)"
                >活动店铺</el-button
              >
              <el-button
                type="text"
                size="small"
                @click="handleManagement('goods', scope.row)"
                >商品管理</el-button
              >
              <el-button
                type="text"
                size="small"
                @click="handleManagement('integral', scope.row)"
                >积分管理</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="handleCurrentChange"
        @prev-click="handleCurrentChange"
        @next-click="handleCurrentChange"
        layout="total,prev, pager, next,jumper"
        :current-page="current"
        :page-size="pageSize"
        :total="total"
        class="pagination"
      >
      </el-pagination>
    </div>

    <!-- 添加和编辑 -->
    <CreateActive ref="createActivities" @refresh="search()"/>
    <!-- 查看 -->
    <ToViewActive ref="toViewActive"/>
  </div>
</template>

<script>
    import {
        uploadFile,
        activitiesListByPage,
        activitiesList,
        getActivitiesDetails,
        saveActivities,
        publishActivities,
        delActivities,
        activitiesStoreListByPage,
        activitiesStoreList,
        activitiesGoodsListByPage,
        activitiesGoodsList,
        getActivitiesGoodsDetails,
        auditActivitiesGoods,
        activitiesStorePointListByPage,
        activitiesStorePointList,
        exchangeActivitiesStore
    } from "../../utils/interface";
import CreateActive from './integralDialog/createActivities'
import ToViewActive from './integralDialog/toViewActive'
    import moment from "moment";
export default {
  // 活动管理
  name: "integralActivitylManagement",
  components:{
      CreateActive,
      ToViewActive
  },
  data() {
    return {
      activityName: "",
      createTime: "",
      activityDate: "",
      activityProcess: "",
      tableData: [
      ],
      current: 1,
      pageSize: 10,
      total: 0,
        form:{},
    };
  },
    mounted() {
        this.search();
    },
  methods: {
      formatterCreateDate(row, column) {
          return moment(row.createTime).format('YYYY-MM-DD');
      },
      formatterActivityDate(row, column){
          if(row.startTime && row.endTime){
              return row.startTime + ' 至 ' + row.endTime;
          } else{
              return "";
          }
      },
      formatterExchangeRate(row, column){
          if(row.exchangeRate){
              return '1元 = ' + row.exchangeRate + ' 积分';
          } else{
              return "";
          }
      },
    search() {
        if(this.activityDate != ""){
            this.form.inputDate = this.activityDate.join(" - ");
        }
        this.form.activityProcess = this.activityProcess;
        this.form.activityName = this.activityName;
        this.form.createTime = this.createTime;
        this.form.current = this.current;
        this.form.pageSize = this.pageSize;
        this.form.activityType = 'INTEGRAL';
        activitiesListByPage(this.form).then((res)=>{
            if(res.success) {
                this.tableData = [];
                this.total = res.data.total;
                this.tableData = res.data.list
            }
        });
    },
    resetData() {
      this.activityName = "";
      this.createTime = "";
      this.activityDate = "";
      this.activityProcess = "";
      this.form.inputDate = "";
        this.search();
    },
    toDialog(type, row) {
        this.$refs.createActivities.init(type, row)
    },
    handleManagement(type, data) {
      if (type == "store") {
        this.$router.push({name:'integralActivitylStore',params:{data:data}});
      } else if (type == "goods") {
        this.$router.push({name:'integralGoodslManagement',params:{data:data}});
      } else if (type == "integral") {
        this.$router.push({name:'merchantsIntegralManagement',params:{data:data}});
      }
    },
      // 详情
    handleIntegralDetails(uuid){
        this.$refs.toViewActive.init(uuid)
    },
    handleCurrentChange(val) {
        this.current = val
        this.search();
    },
      // 删除
      delActivity(uuid){
          this.$confirm('确定要删除当前活动嘛？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
              delActivities(uuid).then((res)=>{
                  if(res.success){
                      this.$message.success("删除成功");
                      this.search();
                  }
              });
          });
      },
      //复制到剪切板
      copyUrl(val){
          this.$message.success(val.activityName +"   的活动地址是 " + this.$url.threeWeb + '/integralActivities/' + val.uuid);
      },
  },
};
</script>

<style lang="less" scoped>
.integral {
  background: #fff;
  margin: 0 20px 20px;
  padding: 20px;

  .integralSearch {
    display: flex;
    flex-wrap: wrap;

    /deep/ .el-input {
      width: initial;
      margin-bottom: 22px;
      margin-right: 30px;
    }

    /deep/ .el-input__inner {
      min-width: 242px;
      height: 35px;
      min-height: 35px;
      font-size: 12px;
      color: #999999;
      background-color: #f2f4f7;
      border: 1px solid #f2f4f7;
      border-radius: 5px;

      &:hover,
      &:focus {
        background-color: #fff;
        border: 1px solid #108ee9;
      }
    }

    /deep/ .el-input__prefix {
      top: -3px;
    }

    /deep/ .el-input__suffix {
      top: 2px;
    }

    /deep/ .el-button {
      display: block;
      line-height: 35px;
      padding: 0;
      height: 35px;
    }

    .searchBtn {
      width: 82px;
      background: #3d7fff;
      border: none;
      border-radius: 15px;
      font-size: 14px;
      color: #ffffff;
    }

    .resetBtn {
      color: #333333;
    }
    .timeSearch {
      margin-right: 25px;
    }
  }
  .toolRight {
    width: 100%;
    text-align: right;
    margin-bottom: 20px;
    button {
      width: 83px;
      height: 30px;
      background: rgba(21, 126, 251, 1);
      border: none;
      border-radius: 15px;
      font-size: 13px;
      color: #fff;

      i {
        padding-right: 5px;
      }

      &:hover {
        background: #61a2f0;
      }
    }
  }
  .integralTable {
    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/integral/integralActivitylManagement.vue